import { Component } from '@angular/core';

@Component({
    selector: 'afm-page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.scss'],
    standalone: false
})
export class PageContentComponent {}
